/*
 Convert key events to standardized names.
 This is a work around for IE 11 using non standard e.key names.
*/
export const processKeyName = (key) => {
    switch(key) {
        case "Up":
            return "ArrowUp";
        case "Down":
            return "ArrowDown";
        case "Left":
            return "ArrowLeft";
        case "Right":
            return "ArrowRight";
        case "Spacebar":
            return " ";
        default:
            return key || "";
    }
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/utils/keyEvents.js